import { connect } from 'react-redux'
import { compose } from 'recompose'
import { defineMessages } from 'react-intl'
import { selectTotalEquity } from '../../../store/selectors/home/equity'
import { withCashOutProps } from '../../../features/homeowners/composables/withMinimumEquityAndGemDisplayProps'
import ifRefiEligible from '../../../features/homeowners/composables/ifRefiEligible'
import { ModuleShown, EVENTS_LABELS } from '../../../constants/trackingEvents'
import withEventOnceOnMount from '../../../composables/withEventOnceOnMount'
import { EquityPanel } from '../../../constants/notificationRefs'
import gems from './gems'

const defaultDM = defineMessages({
  question: {
    id: 'Homeowner.equity.defaultQuestion',
    defaultMessage: 'What option is best for me?',
  },
  topic: {
    id: 'Homeowner.equity.defaultTopic',
    defaultMessage: 'using their equity',
  },
})

const CashOutContainer = compose(
  withCashOutProps({
    gems,
    defaultDM,
    cardRef: EquityPanel,
    padding: 50,
  }),
  ifRefiEligible,
  connect(state => ({
    equity: selectTotalEquity(state),
  })),
  withEventOnceOnMount(ModuleShown, {
    eventLabel: EVENTS_LABELS.CashOutModule,
  })
)

export default CashOutContainer
